import React, { useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { satc_DiscountCard } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useTranslation } from "react-i18next";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { Skeleton } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getAccountingDiscountCard, getActivePeriods } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import AddDiscountCard from "./AddDiscountCard";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";

export default function DiscountCard() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState();
  const [columns, setColumns] = useState([]);
  const {
    accountingDiscountCard,
    activePeriods,
    getDiscountCardAgain,
    pagination,
  } = useSelector((state) => ({
    accountingDiscountCard: state.saAccounts.accountingDiscountCard,
    activePeriods: state.saAccounts.activePeriods,
    getDiscountCardAgain: state.saAccounts.getDiscountCardAgain,
    pagination: state.saAccounts.pagination,
  }));
  const [controls, setControls] = useSetState({
    periods: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
  });

  useEffect(() => {
    onEnter();
  }, []);

  const onEnter = async () => {
    setLoading(true);
    const _columns = [...satc_DiscountCard];
    _columns[14].hidden = !read("FormDiscount").accessUpdate;
    _columns[15].hidden = !read("FormDiscount").accessDelete;
    // _columns[16].hidden = !read("FormDefaultCredit").accessPrice2;
    setColumns(_columns);
    await getPeriods();
    await getDiscountCard(1, sizePerPage);
  };

  const getDiscountCard = async (_page, _sizePerPage, dataSearch = null) => {
    setLoading(true);
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: _sizePerPage,
        Page: _page,
        ...dataSearch,
      };
      await dispatch(getAccountingDiscountCard(params));
      setLoading(false);
      resolve(true);
    });
  };

  const getPeriods = async () => {
    return new Promise(async (resolve) => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
      };
      await dispatch(getActivePeriods(params));
      resolve(true);
    });
  };

  useEffect(() => {
    if (accountingDiscountCard) {
      setTblData(accountingDiscountCard);
      setSizePerPage(pagination.Limit);
      setCurrentPage(pagination.Page);
      setTotal(pagination.Total);
    }
  }, [accountingDiscountCard]);

  useEffect(() => {
    if (activePeriods) {
      const defArr = [{ label: t("chooseOnePeriod"), value: -1 }];
      const selectItems = activePeriods.map((child) => {
        return {
          label: child.Name,
          value: child.Id,
        };
      });
      setControls({ periods: { selectItems: defArr.concat(selectItems) } });
      setControls({ periods: { value: defArr[0] } });
    }
  }, [activePeriods]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await tblRefresh(page, sizePerPage);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    await tblRefresh(1, sizePerPage, value.value);
  };

  useEffect(() => {
    if (getDiscountCardAgain) {
      (async () => {
        await tblRefresh(currentPage, sizePerPage);
      })();
    }
  }, [getDiscountCardAgain]);

  const tblRefresh = async (innerPage, innerSizePerPage, period = null) => {
    let dataSearch = {}; //periodId
    const { periods } = controls;
    if (period) {
      if (period !== -1) {
        dataSearch.PeriodId = period;
      }
    } else if (periods.value.value !== -1) {
      dataSearch.PeriodId = periods.value.value;
    }
    await getDiscountCard(innerPage, innerSizePerPage, dataSearch);
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id="discountCard" />} />
        <div className="top-buttons">
          <AddDiscountCard disabled={loading} />
        </div>
      </div>
      <MuiPaper>
        <Grid container spacing={2} className="mb-2">
          <Grid item md={3} sm={6} xs={12}>
            {!loading ? (
              <MuiAutoComplete
                autoSelect={true}
                options={controls.periods.selectItems}
                label={<Translator id="periods" />}
                value={controls.periods.value}
                onChange={autoCompleteHandler}
                id={"periods"}
              />
            ) : (
              <Skeleton variant="text" className="p-2" animation="wave" />
            )}
          </Grid>
        </Grid>
        {columns && columns.length !== 0 && (
          <RemoteTable
            data={tblData}
            columns={columns}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        )}
      </MuiPaper>
    </>
  );
}
